if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type=submit]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
              this.showAddedPopup(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      showAddedPopup(response) {
        if (window.location.pathname.indexOf('/products/') === -1) return;
        if (window.location.search.indexOf('view=') > -1) return;

        const old = document.getElementById('atc-popup');
        if (old) old.remove();

        const esc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

        if (!document.getElementById('atc-popup-css')) {
          const st = document.createElement('style');
          st.id = 'atc-popup-css';
          st.textContent =
            '#atc-popup{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.55)}' +
            '#atc-popup .atc-box{background:#fff;color:#121212;max-width:460px;width:100%;border-radius:12px;padding:22px;box-shadow:0 10px 40px rgba(0,0,0,.3);max-height:90vh;overflow:auto}' +
            '#atc-popup h2{margin:0 0 4px;font-size:20px;color:#1a7f37}' +
            '#atc-popup .atc-item{margin:0 0 14px;font-size:14px;color:#555}' +
            '#atc-popup .atc-pt{display:flex;gap:10px;margin:10px 0;padding:10px 12px;background:#f5f7fb;border-left:3px solid #002366;border-radius:4px;font-size:14px;line-height:1.45}' +
            '#atc-popup .atc-pt b{display:block;margin-bottom:2px}' +
            '#atc-popup .atc-ic{font-size:20px;line-height:1.2}' +
            '#atc-popup .atc-btns{display:flex;gap:10px;margin-top:16px;flex-wrap:wrap}' +
            '#atc-popup button{flex:1;min-width:140px;padding:12px;font-size:15px;font-weight:700;border-radius:8px;cursor:pointer;border:1px solid #002366}' +
            '#atc-popup .atc-pri{background:#002366;color:#fff}' +
            '#atc-popup .atc-sec{background:#fff;color:#002366}';
          document.head.appendChild(st);
        }

        const title = response && response.product_title ? response.product_title : 'Your product';
        const qty = response && response.quantity ? response.quantity : 1;

        const wrap = document.createElement('div');
        wrap.id = 'atc-popup';
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.setAttribute('aria-labelledby', 'atc-popup-title');
        wrap.innerHTML = `<div class='atc-box'>
          <h2 id='atc-popup-title'>&#10003; Thank you, added to cart!</h2>
          <p class='atc-item'>${esc(title)} &times; ${esc(qty)}</p>
          <div class='atc-pt'><span class='atc-ic'>&#128197;</span><div><b>Our weekly timeline</b>Orders are consolidated every <strong>Sunday at 17:00</strong>. Collections and Pudo drops are usually ready <strong>Tuesday/Wednesday</strong>.</div></div>
          <div class='atc-pt'><span class='atc-ic'>&#127912;</span><div><b>About colours</b>Where no colour option is given, <strong>available colours will be supplied</strong>. If you leave a note with a colour request, we will try our best to match it, but it all depends on availability.</div></div>
          <div class='atc-btns'><button type='button' class='atc-sec' data-atc=continue>Continue shopping</button><button type='button' class='atc-pri' data-atc=cart>View cart</button></div>
        </div>`;
        document.body.appendChild(wrap);

        const cart = this.cart;
        const onKey = (e) => {
          if (e.key === 'Escape') close();
        };
        const close = () => {
          wrap.remove();
          document.removeEventListener('keydown', onKey);
        };
        document.addEventListener('keydown', onKey);
        wrap.addEventListener('click', (e) => {
          if (e.target === wrap) close();
        });
        const continueBtn = wrap.querySelector('[data-atc=continue]');
        continueBtn.addEventListener('click', () => {
          close();
          if (cart && typeof cart.close === 'function') cart.close();
        });
        wrap.querySelector('[data-atc=cart]').addEventListener('click', close);
        setTimeout(() => continueBtn.focus(), 50);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
